import { useState as m, useCallback as R } from "react";
import "react/jsx-runtime";
import "immutable";
import { u as d } from "../refs-CANlwHhW.js";
import { R as l } from "../result-BPlAbaTC.js";
class y extends Error {
}
function c(r) {
  if (r.kind === "success")
    return r.result;
  if (r.kind === "loading" || r.kind === "error")
    return r.previousResult;
}
function E(r, s = {}) {
  switch (r) {
    case "loading":
      return { kind: r, progress: s.progress ?? "indeterminate", previousResult: s.result ?? void 0 };
    case "success":
      return { kind: r, result: s.result ?? null };
    case "error":
      return { kind: r, err: s.err, previousResult: s.result ?? void 0 };
    case "initial":
      return { kind: r };
  }
}
function F(r, s) {
  const [u, o] = m({ kind: "initial" }), a = d(r), t = d(s);
  return [R(
    async (...p) => {
      let i = l.err(void 0);
      try {
        o((n) => ({ kind: "loading", progress: "indeterminate", previousResult: c(n) })), t.current?.onLoading?.();
        const e = await a.current(...p, {
          progressCb(n) {
            o((f) => ({ kind: "loading", progress: n, previousResult: c(f) }));
          }
        });
        return o({ kind: "success", result: e }), t.current?.onSuccess?.(e), i = l.ok(e), e;
      } catch (e) {
        throw console.warn("[useAsync] asyncFn threw an error", e), o((n) => ({ kind: "error", err: e, previousResult: c(n) })), t.current?.onError?.(e), i = l.err(e), e;
      } finally {
        t.current?.onSettled?.(i);
      }
    },
    [a, t]
  ), u];
}
function A(r) {
  return new Promise((s, u) => {
    Math.random() < r ? u(new Error(`Random failure (probability: ${r})`)) : s();
  });
}
export {
  y as AbortError,
  c as asyncResultFrom,
  E as asyncStateFrom,
  F as useAsync,
  A as withFailureProbability
};
//# sourceMappingURL=index.js.map
